module.exports = __webpack_public_path__ + "static/media/home-lg-alt.4b794fd4.svg";